<template>
  <div class="pageContainer">
    <UploadAnalysisResultsVue />
    <Modal v-if="isShow" />
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { mapState } from 'vuex';
import UploadAnalysisResultsVue from '../../components/Saai/UploadAnalysisResults/UploadAnalysisResults.vue';

export default {
  name: 'CreateImprovedFeedback',
  components: {
    UploadAnalysisResultsVue,
    Modal,
  },
  methods: {

  },
  computed: {
    ...mapState('modal', ['isShow']),
    ...mapState('login', ['isLogin']),
  },
  created() {
    let content;
    let url;

    if (!this.isLogin) {
      content =
        this.$i18n.locale === 'eng' ? 'Please sign in to use.' : '로그인이 필요한 서비스입니다.';
      url = '/login';
      this.AC_MODAL_OPEN({
        content: content,
        url: url,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.pageContainer {
  height: 100%;
}
</style>
